import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { getText } from '../../../../internal/TextLabels'
import CreditPlan from '../../../../components/OneProduct/CreditPlan'
import CreditInfo from '../../../../components/OneProduct/CreditInfo'
import SendMailModalForm from '../../../../components/SendMailModalForm'
import { format } from '../../../../models/format'
import CreditSlider from '../../../../components/OneProduct/CreditSlider'
import { useToggle } from '../../../../util/utility-hooks'

export const DynamicPaymentPlans = ({
  costAlternatives,
  monthlyCost,
  sendPriceInfoMail,
  getPaymentPerMonth,
  methodDescription,
  methodId,
  amount,
  months,
}) => {
  const [email, setEmail] = useState('')
  const [showEmailModal, toggleShowEmailModal] = useToggle(false)
  const [creditCost, setCreditCost] = useState({ months })
  useEffect(
    () => getPaymentPerMonth(methodId, amount, creditCost.months),
    [creditCost, amount, methodId],
  )
  return (
    <>
      <SendMailModalForm
        show={showEmailModal}
        disableInput={!new RegExp(format.email.regex).exec(email)}
        disabled={false}
        message={getText(
          'payApply.priceSignageCost.emailForSendingCalculation',
        )}
        onClose={toggleShowEmailModal}
        inputValue={email}
        onChange={setEmail}
        onSubmit={() =>
          sendPriceInfoMail(methodId, creditCost.months, amount, email)
        }
      />
      <div style={{ display: 'flex' }}>
        <div
          style={{
            flex: '50%',
            padding: '1rem 0 0 0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <div>
              {`${methodDescription} - `}{' '}
              <NumberFormat
                value={amount}
                displayType="text"
                thousandSeparator=" "
                renderText={val => getText('default.currency', val)}
              />
            </div>
            <div>
              <CreditPlan
                costAlternatives={costAlternatives}
                months={creditCost.months}
                monthlyCost={monthlyCost.monthlyCost}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            alignSelf: 'flex-end',
            marginLeft: '0.5rem',
          }}
        >
          <CreditInfo
            cost={monthlyCost}
            limit={+amount}
            onSendMail={toggleShowEmailModal}
          />
        </div>
      </div>
      <CreditSlider values={costAlternatives} onChange={setCreditCost} />
    </>
  )
}
